(() => {
  const root = document.querySelector('[data-mdc]');
  if (!root) return;

  const tabs = Array.from(root.querySelectorAll('[data-mdc-tab]'));
  const contenido = root.querySelector('[data-mdc-contenido]');
  const cargando = root.querySelector('[data-mdc-cargando]');
  const panel = root.querySelector('[data-mdc-panel]');
  if (!tabs.length || !contenido) return;

  const setLoading = (on) => { if (cargando) cargando.hidden = !on; };
  const setActive = (tab) => {
    tabs.forEach(t => t.setAttribute('aria-current', t === tab ? 'true' : 'false'));
  };

  const fetchHtml = async (collectionUrl) => {
    const url = new URL(collectionUrl, window.location.origin);
    url.searchParams.set('section_id', 'drawer-grid-productos-coleccion');
    const res = await fetch(url.toString(), { headers: { 'Accept': 'text/html' } });
    if (!res.ok) throw new Error('Fetch failed');
    return await res.text();
  };

  const load = async (tab) => {
    const url = tab.dataset.url;
    setActive(tab);

    // sube el scroll del panel al cambiar
    if (panel) panel.scrollTop = 0;

    setLoading(true);
    try {
      const html = await fetchHtml(url);
      contenido.innerHTML = html;
    } catch (e) {
      contenido.innerHTML = `<p role="status">No se pudo cargar. <a href="${url}">Abrir colección</a></p>`;
    } finally {
      setLoading(false);
    }
  };

  tabs.forEach(tab => {
    tab.addEventListener('click', (ev) => {
      ev.preventDefault();
      load(tab);
    });
  });

  // Dejar "TODOS" activo al abrir (si existe)
  const allTab = tabs.find(t => {
    try { return new URL(t.dataset.url, window.location.origin).pathname.includes('/collections/all'); }
    catch { return false; }
  });
  if (allTab) setActive(allTab);
})();